<template lang="pug">
  .abilityGroup
    p.abilityGroup__title 派車單
    .abilityGroup__item
      span.abilityGroup__subtitle 派車單總查詢
      BaseAbilityRadioGroup(
        :value="abilityTransaction"
        :disabled="disabled"
        :uneditableAbility="true"
        @handleRadioChange="setAbilityTransaction")
    .abilityGroup__item
      span.abilityGroup__subtitle 派車單單月統計
      BaseAbilityRadioGroup(
        :value="abilityTransactionStatistics"
        :disabled="disabled"
        :uneditableAbility="true"
        @handleRadioChange="setAbilityTransactionStatistics")
</template>
<script>
import BaseAbilityRadioGroup from '@/components/common/select/BaseAbilityRadioGroup'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      abilityTransaction: 'positionStore/getCurrentAbilityTransaction',
      abilityTransactionStatistics:
        'positionStore/getCurrentAbilityTransactionStatistics',
    }),
  },
  methods: {
    ...mapActions({
      setAbilityTransaction: 'positionStore/setAbilityTransaction',
      setAbilityTransactionStatistics:
        'positionStore/setAbilityTransactionStatistics',
    }),
  },
  components: {
    BaseAbilityRadioGroup,
  },
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_abilityGroup';
</style>



// WEBPACK FOOTER //
// src/pages/manager/AbilityRadioGroup/AbilityGroupTransactionItems.vue